import { useMedplum, useMedplumProfile } from '@medplum/react-hooks';
import { useEffect, useState } from 'react';
import {
  getMessageableRecipients,
  type MessageableRecipient,
} from '../services/recipientEligibility';

/**
 * Returns the list of users the current user is allowed to message.
 * Queries EoC/CareTeam/Practitioner based on role.
 */
export function useMessageableRecipients(): {
  recipients: MessageableRecipient[];
  loading: boolean;
  restrictToOwnProviders: boolean;
} {
  const medplum = useMedplum();
  const profile = useMedplumProfile();
  const isPatientUser = profile?.resourceType === 'Patient';

  const [recipients, setRecipients] = useState<MessageableRecipient[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!profile?.id) {
      setRecipients([]);
      return;
    }

    setLoading(true);
    getMessageableRecipients(medplum, profile)
      .then((r) => {
        // TODO: For patient users, filter recipients to providers from active EpisodeOfCare/CareTeam.
        // Currently returns all available providers — backend integration needed for care relationship filtering.
        setRecipients(r);
      })
      .catch((err) => {
        console.error('[Messaging] Failed to load recipients:', err);
        setRecipients([]);
      })
      .finally(() => setLoading(false));
  }, [medplum, profile]);

  return { recipients, loading, restrictToOwnProviders: isPatientUser };
}
